import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import {
  Container,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { CustomBootstrapTable } from 'components/Table/CustomBootstrapTable';
import { WordsColumn,getMuiTheme } from "helpers/tableDataMapper";
import { useSelector, useDispatch } from "react-redux";
import {
    getWords
} from "store/words/actions";

const WordsDeletedList = (props) => {
    const dispatch = useDispatch();

    const { wordsList } = useSelector(state => ({
        wordsList: state.words.wordsList,
    }));
    
    useEffect(() => {
        let queryPayload = {
            search: '',
            isDeleted: true
        }
        dispatch(getWords(queryPayload));
    }, [getWords]);

    const getApplicationDetails = (row) => {
        props.history.push(`/staff/word/detail/${row[1]}`)
    }

    const filterList = (queryPayload) => {
        queryPayload = {
            ...queryPayload,
            isDeleted: true
        }
        dispatch(getWords(queryPayload))
    }
    
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Words Master" breadcrumbItem="Deleted Words List" />
                    <CustomBootstrapTable 
                        rows = {wordsList}
                        columns = {WordsColumn}
                        isLoading={false}
                        showCreateBtn = {false}
                        keyField={'_id'}
                        filterList = {(...params) => filterList(...params)}
                        getApplicationDetails={() => null}
                        showStatusFilter={false}
                        showDateFilter={false}
                        history = {props.history}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}

export { WordsDeletedList }